import React from "react";
import "./ECLDatePicker.css";
import { dateToDatetimeLocal } from "./DateHelpers";
const allTimezones = Intl.supportedValuesOf("timeZone");
//Props
// date - string optional - Initial date value
// changeDate - function Required - Function for the input's onChange event
// id - string optional - used to set the input's id, please use if using multiple date pickers on the same page
// reference - useRef value optional - used to set ref for focus, use if necessary
// name - string optional - displays as label if passed in
// timeZone - a string that will be used to get the name of the time zone being used
// min - a string that has the minimum date
// max - a string that has the maximum date
// onChange - function that calls when the input changes

export default function ECLDateTimePicker(props) {
   // Need a special function to translate a JS date object into something that works with datetime-local, since
   // no one wants to work with time (Maybe Temporal fixes this eventually?).
   // Answer from this stack overflow: https://stackoverflow.com/questions/28760254/assign-javascript-date-to-html5-datetime-local-input
   // Benefits:
   //    -uses a JS date constructor passing in the time, accepts a wide range of time formats automatically.
   //    -is timezone aware, which for our purposes, means that it should sync up with our arrow IPC data
   return (
      <>
         {props.timeZone ? (
            <>
               {props.name && (
                  <label htmlFor={props.id || "date-picker"}>
                     {props.name}
                     {props.required && (
                        <span className="required-input">*</span>
                     )}
                  </label>
               )}
               <h4 data-testid={props.id}>Time Zone: {props.timeZone}</h4>
               <input
                  type="datetime-local"
                  className="datetime-local-input"
                  id={props.id || "datetime-local-picker"}
                  onChange={props.onChange}
                  // Set default value to show min/max in input without restricting calendar
                  defaultValue={
                     props.date
                        ? dateToDatetimeLocal(props.date)
                        : dateToDatetimeLocal(new Date().toString())
                  }
                  min={props.min && dateToDatetimeLocal(props.min)}
                  max={props.max && dateToDatetimeLocal(props.max)}
                  required={props.required}
                  tabIndex={props.tabIndex}
               />
               {/* If the user is allowed to select a timezone and send it back to the server */}
               <select
                  data-testid={props.id}
                  key={"select-" + props.id}
                  id={"select-" + props.id}
                  defaultValue={props.timeZone}
               >
                  {allTimezones.map((tz, i) => (
                     <option key={"select-" + props.id + i}>{tz}</option>
                  ))}
               </select>
            </>
         ) : (
            <>
               {props.name && (
                  <label htmlFor={props.id || "date-picker"}>
                     {props.name}
                     {props.required && (
                        <span className="required-input">*</span>
                     )}
                  </label>
               )}
               <input
                  type="datetime-local"
                  className="datetime-local-input"
                  id={props.id || "datetime-local-picker"}
                  onChange={props.onChange}
                  // Display min/max dates without restricting calendar
                  defaultValue={
                     props.date
                        ? dateToDatetimeLocal(props.date)
                        : dateToDatetimeLocal(new Date().toString())
                  }
                  min={props.min && dateToDatetimeLocal(props.min)}
                  max={props.max && dateToDatetimeLocal(props.max)}
                  required={props.required}
                  tabIndex={props.tabIndex}
               />
            </>
         )}
      </>
   );
}
